customElements.get("fade-slider") || customElements.define("fade-slider", class extends HTMLElement {
  constructor() {
    super(), this.fadeSpeed = parseInt(this.dataset.fadeSpeed) || 5;
  }
  connectedCallback() {
    this.slides = this.querySelectorAll("li"), this.currentSlide = 0, this.slides[this.currentSlide].removeAttribute("aria-hidden"), 
    this.closeButton = this.querySelector("button"), this.closeButton && this.closeButton.addEventListener("click", () => {
      this.close();
    }), this.slides.length > 1 && (this.interval = setInterval(() => {
      this.nextSlide();
    }, 1e3 * this.fadeSpeed));
  }
  disconnectedCallback() {
    this._cleanup();
  }
  _cleanup() {
    this.interval && (clearInterval(this.interval), this.interval = null), this.closeButton && (this.closeButton.replaceWith(this.closeButton.cloneNode(!0)), 
    this.closeButton = null), this.slides = null;
  }
  nextSlide() {
    this.slides && 0 !== this.slides.length && (this.slides[this.currentSlide].setAttribute("aria-hidden", "true"), 
    this.currentSlide = (this.currentSlide + 1) % this.slides.length, this.slides[this.currentSlide].removeAttribute("aria-hidden"));
  }
  close() {
    this._cleanup(), sessionStorage.setItem("announcement-closed", "true");
    const e = this.closest("[data-announcement]"), t = e?.getBoundingClientRect().height || 0;
    if (!e || 0 === t) return this.style.display = "none", void document.documentElement.classList.add("announcement-dismissed");
    const s = !!document.querySelector("main > .shopify-section.section--media-banner:first-child"), n = () => {
      this.style.display = "none", e.style.marginTop = null, document.documentElement.classList.add("announcement-dismissed"), 
      window.MBF?.updateVisualViewport && window.MBF.updateVisualViewport();
    };
    if (s) {
      const s = document.querySelector(".section--header"), i = "transform 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000)";
      e.style.transition = i, e.style.transform = "translateY(-100%)", s && (s.style.transition = i, 
      s.style.transform = `translateY(-${t}px)`);
      const l = t => {
        t.target === e && "transform" === t.propertyName && (e.removeEventListener("transitionend", l), 
        s && (s.style.transition = "none", s.style.transform = "", s.getBoundingClientRect(), 
        s.style.transition = ""), n());
      };
      e.addEventListener("transitionend", l);
    } else {
      const s = performance.now(), i = l => {
        const r = Math.min((l - s) / 300, 1);
        var o;
        e.style.marginTop = `-${t * (o = r, o < .5 ? 4 * o * o * o : 1 - Math.pow(-2 * o + 2, 3) / 2)}px`, 
        r < 1 ? requestAnimationFrame(i) : n();
      };
      requestAnimationFrame(i);
    }
  }
});